/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gem_Pack_1_TitleInputs */

const en_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shovel of Crystals`)
};

const ar_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجرفة البلورات`)
};

const de_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Schaufel Kristalle`)
};

const es_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pala de cristales`)
};

const fr_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelletée de Gemmes`)
};

const it_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vangata di Cristalli`)
};

const ja_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シャベル一杯の結晶`)
};

const ko_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리스탈 한 스푼`)
};

const pt_br_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pá de cristais`)
};

const ru_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лопата кристаллов`)
};

const th_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คริสตัลหนึ่งพลั่ว`)
};

const tr_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Kepçe Kristal`)
};

const zh_cn_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一铲子宝石`)
};

const zh_tw_gem_pack_1_title = /** @type {(inputs: Gem_Pack_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一鏟子寶石`)
};

/**
* | output |
* | --- |
* | "Shovel of Crystals" |
*
* @param {Gem_Pack_1_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const gem_pack_1_title = /** @type {((inputs?: Gem_Pack_1_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gem_Pack_1_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gem_pack_1_title(inputs)
	if (locale === "ar") return ar_gem_pack_1_title(inputs)
	if (locale === "de") return de_gem_pack_1_title(inputs)
	if (locale === "es") return es_gem_pack_1_title(inputs)
	if (locale === "fr") return fr_gem_pack_1_title(inputs)
	if (locale === "it") return it_gem_pack_1_title(inputs)
	if (locale === "ja") return ja_gem_pack_1_title(inputs)
	if (locale === "ko") return ko_gem_pack_1_title(inputs)
	if (locale === "pt_br") return pt_br_gem_pack_1_title(inputs)
	if (locale === "ru") return ru_gem_pack_1_title(inputs)
	if (locale === "th") return th_gem_pack_1_title(inputs)
	if (locale === "tr") return tr_gem_pack_1_title(inputs)
	if (locale === "zh_cn") return zh_cn_gem_pack_1_title(inputs)
	return zh_tw_gem_pack_1_title(inputs)
});